
  import { defineComponent } from 'vue';
  import './tooltip.scss';

  /**
    * Form help text / Tooltip
    * 
    * @example
    * <code>import TpxTooltip from '@manifesto-tech/tpximpact-design-system/components/atoms/form/tooltip.vue'</code>
    */
  export default defineComponent({
    name: 'TpxTooltip',
    
    props: {
      /**
       * The help text
       */
      tooltip: {
        type: String,
      },
    },
  });
